import { IconChevronLeft } from '@tabler/icons-react'
import clsx from 'clsx'

import { Button } from 'src/components/Button/Button'
import { Text } from 'src/components/Text/Text'

import styles from './Banner.module.scss'

interface BannerProps {
  link?: {
    url: string
    text: string
  }
  headline: string
  subText: string
  small?: boolean
}

export const Banner = ({ link, headline, subText, small }: BannerProps) => (
  <div className={styles.container}>
    {link && (
      <Button
        variant="ghost"
        inverted
        className={styles.goBackButton}
        startIcon={<IconChevronLeft />}
        href={link?.url}
        aria-label={`back to ${link?.text}`}
      >
        {link?.text}
      </Button>
    )}
    <Text className={styles.headline}>{headline}</Text>
    <Text className={clsx(styles.subText, small && styles.small)}>{subText}</Text>
  </div>
)
